import styled from 'styled-components';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';

export const DataGrid = styled(MuiDataGrid)`
  .MuiDataGrid-row {
    cursor: pointer;
  }

  .descriptionCell {
    // Turning off MUI data-grid cells custom text overflow rules, because they
    // conflict with custom rules needed for description column.
    white-space: initial !important;
  }

  .MuiDataGrid-toolbarContainer {
    position: absolute;
    top: -48px;
    left: 0;
    padding: 0;
  }

  .MuiDataGrid-columnSeparator {
    display: none !important;
  }
`;

const Cell = styled.span`
  font-family: 'Montserrat', sans-serif;
`;

DataGrid.Name = styled(Cell)`
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
`;

DataGrid.Description = styled(Cell)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.3;
  color: #616161;
  font-size: 18px;
`;

DataGrid.Rate = styled.div`
  padding: 4px 8px;
`;

DataGrid.Status = styled(Cell)`
  color: #616161;
  font-size: 18px;
`;

DataGrid.Date = styled(Cell)`
  color: #616161;
  font-size: 18px;
`;

export const NoCampaignsButton = styled.button`
  border-radius: 6px;
  background-color: #208ae2;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Poppins';
  border: 1px solid #208ae2;
  padding: 8px 50px;
  margin-top: 20px;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease-in;

  &:hover {
    background-color: #ffffff;
    color: #208ae2;
  }
`;

export const NoRowsOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70%;
  padding: 20px;
  color: #212121;
  font-size: 18px;
  pointer-events: auto;
  font-family: 'Poppins';
  font-weight: 500;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  padding-top: 48px;
`;

export const TableToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  gap: 16px;
`;

export const DensitySelectorContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;
